import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { Parallax } from "react-parallax";
import { AppContext } from '../main';


const Section = (props) => {
    const {
        handleEditItem
    } = props

    const { appState
    } = useContext(AppContext);
    const {
        populars = {
            // title: "Popular",
            // subtitle: "Game Servers",
            // games: [
            //     { name: "Thunder and City", image: "../../img/covers-square/1.webp" },
            //     { name: "Mystic Racing", image: "../../img/covers-square/2.webp" },
            //     { name: "Silent Wrath", image: "../../img/covers-square/3.webp" },
            //     { name: "Funk Dungeon", image: "../../img/covers-square/4.webp" },
            //     { name: "Galactic Odyssey", image: "../../img/covers-square/5.webp" },
            //     { name: "Warfare Legends", image: "../../img/covers-square/6.webp" },
            //     { name: "Raceway Revolutions", image: "../../img/covers-square/7.webp" },
            //     { name: "Starborne Odyssey", image: "../../img/covers-square/8.webp" }
            // ]
        }
        , editMode = false
    } = appState

    if (!populars?.games) {
        return null
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="subtitle mb-3">{populars.title}</div>
                    <h2 className="mb20" data-wow-delay=".2s">{populars.subtitle}</h2>
                </div>
                {populars.games.map((game, index) => (
                    <div key={index} className="col-lg-3 col-md-4 col-6 text-center">
                        <Link to="/">
                            <img src={game.image} className="img-fluid rounded-10 mb-3" alt={game.name} />
                            <h6>{game.name}</h6>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Section;
